import api from "@/lib/api";

// LIST (optional filters)
export const getPayoutList = async ({ firm_id, payment_method } = {}) => {
  const body = {};
  if (firm_id) body.firm_id = firm_id;
  if (payment_method) body.payment_method = payment_method;
  const res = await api.post("/payouts/getPayoutList", body);
  return res.data;
};

// GET BY ID
export const getPayoutById = async (id) => {
  const res = await api.post("/payouts/getById", { id });
  return res.data;
};

// COUNT (optional status in body if backend supports it)
export const getPayoutCount = async (status) => {
  const res = await api.post("/payouts/getCount", status ? { status } : {});
  return res.data;
};

// MODERATE (verify / reject)
export const moderatePayout = async ({ id, status, moderator_note = "" }) => {
  const res = await api.post("/payouts/moderate", {
    id,
    status,
    moderator_note,
  });
  return res.data;
};

// DELETE
export const deletePayout = async (id) => {
  const res = await api.post("/payouts/delete", { id });
  return res.data;
};

// CREATE (multipart)
export const createPayout = async ({
  firm_id,
  amount,
  days_to_receive,
  payment_method,
  proof_of_payment,
}) => {
  const formData = new FormData();
  formData.append("firm_id", firm_id);
  formData.append("amount", amount);
  formData.append("days_to_receive", days_to_receive ?? 0);
  formData.append("payment_method", payment_method);
  if (proof_of_payment) {
    formData.append("proof_of_payment", proof_of_payment);
  }
  const res = await api.post("/payouts/create", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

// EVIDENCE
export const getPayoutEvidence = async (filename) => {
  const res = await api.post("/payouts/getPayoutEvidence", { filename });
  return res.data;
};